/**
 * Auth context hook - separate file for Vite Fast Refresh compatibility.
 */

import { useContext } from 'react';
import { AuthContext } from './AuthProvider';

/**
 * Use auth context
 * @returns {Object} Auth context value
 */
export const useAuthContext = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuthContext must be used within AuthProvider');
  }
  return context;
};
